module.exports = __webpack_public_path__ + "static/media/Teachers.db2cb142.jpg";